
import { SectionCardData } from "@/lib/singularity/section-add-or-swap";
import SingularityBadge from "@/components/Singularity/components/SingularityBadge.vue";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    SingularityBadge
  }
})
export default class SectionCard extends Vue {
  @Prop()
  value!: SectionCardData;

  @Prop()
  currentSection!: boolean;

  @Prop()
  showLabel!: boolean;

  @Prop({ default: false })
  isGlobal!: boolean;

  @Prop({ default: "default" })
  layout!: "default" | "detailed";

  @Prop({ default: "auto" })
  maxHeight!: string | number;

  get imageStyles() {
    return {
      maxHeight:
        typeof this.maxHeight === "number"
          ? `${this.maxHeight}px`
          : this.maxHeight
    };
  }
}
